export const messagePrefix = 'subscription-manager';

const messenger = {
  create(message: string): string {
    return `[${messagePrefix}]: ${message}`;
  },

  missingData(dataType: string): string {
    return messenger.create(`"${dataType}" is missing, fetch the data before using`);
  },

  missingService(serviceType: string, libraryName: string): string {
    return messenger.create(
      `"${serviceType}" (${libraryName}) instance isn't passed to the library.`
    );
  },
};

export default messenger;
